<div class="row align-items-baseline">
  <div class="col-xxl-3 d-flex align-items-baseline">
    <h4>
      {{ contract().name }}
      <app-badge-organization [code]="contract().number" />
    </h4>
  </div>
  <div class="col-xxl-9">
    <div class="row">
      <div class="col-xl-3 col-md-6">
        <span class="label">{{ 'Contract.type' | translateLabel }}</span>
        <span>{{ 'Contract.typeEnum.' + contract().type | translate }}</span>
      </div>
      <div class="col-xl-3 col-md-6">
        <span class="label">{{ 'Contract.startDate' | translateLabel }}</span>
        <span class="date">{{ contract().startDate | dateFormat: 'date' : '—' }}</span>
      </div>
      <div class="col-xl-3 col-md-6">
        <span class="label">{{ 'Contract.renewDate' | translateLabel }}</span>
        <span class="date">{{ contract().renewalDate | dateFormat: 'date' : '—' }}</span>
      </div>
      <div class="col-xl-3 col-md-6">
        <span class="label">{{ 'Contract.endDate' | translateLabel }}</span>
        <span class="date">{{ contract().endDate | dateFormat: 'date' : '—' }}</span>
      </div>
    </div>
  </div>
</div>

<div id="contract-plans" class="row border border-1 bg-light py-2 mt-2 mb-4">
  <div class="col-xxl-3 col-md-6">
    {{ 'Contract.cdnEnabled' | translateLabel }}
    @if (contract().cdnEnabled) {
      <span class="icofont icofont-ui-check text-success"></span>
    } @else {
      <span class="icofont icofont-ui-close text-danger"></span>
    }
  </div>
  <div class="col-xxl-9">
    <div class="row">
      <div class="col-xl-3 col-md-6">
        {{ 'requests' | translateLabel }}
        @if (contract().millionRequestsPerMonth) {
          {{ contract().millionRequestsPerMonth }}M/{{ 'month' | translate }}
        } @else {
          —
        }
      </div>
      <div class="col-xl-3 col-md-6">
        {{ 'bandwidth' | translateLabel }}
        @if (contract().bandwidthPerMonth) {
          {{ formatSize(contract().bandwidthPerMonth * BANDWIDTH_UNIT) }}/{{ 'month' | translate }}
        } @else {
          —
        }
      </div>
      <div class="col-xl-3 col-md-6">
        {{ 'Contract.nbSitesAdvanced' | translateLabel }} {{ contract()?.nbSitesAdvanced ?? '—' }}
      </div>
      <div class="col-xl-3 col-md-6">
        {{ 'Contract.nbSitesExpert' | translateLabel }} {{ contract()?.nbSitesExpert ?? '—' }}
      </div>
    </div>
  </div>
</div>
